import { render } from "./BoqHistory.vue?vue&type=template&id=ff01a226&scoped=true"
import script from "@/assets/boq/BoqHistory.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqHistory.js?vue&type=script&lang=js"

import "./BoqHistory.vue?vue&type=style&index=0&id=ff01a226&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff01a226"]])

export default __exports__